import React from 'react'
import { Link } from 'react-router-dom'

const StoreNew = () => {
  return (
    <div className='store-full'>
        
        <div className='store-box'>
            <div className='store-box-wrap'>
                <span class="scrolldiv" id='newdelhi'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>The Experience Center <small>{/* Naraina, */} New Delhi</small></div>
                    <div className='store-link'><span><Link to="/aboutchaashni#the-experience-center-new-delhi">Explore</Link> <Link to="https://chaashnicouture.com/book-appointment/" target='_blank'>Book an Appointment</Link></span></div>
                </div>
                <img src='/images/delhi-showroom.jpg' alt='The Experience Center New Delhi' />            
            </div>
        </div>
        <div className='store-box'>
            <div className='store-box-wrap'>
                 <span class="scrolldiv" id='dubai'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>THE GULF FLAGSHIP <small>{/* Naraina, */} Dubai</small></div>
                    <div className='store-link'><span><Link to="/aboutchaashni#the-gulf-flagship-dubai">Explore</Link> <Link to="https://chaashnicouture.com/book-appointment/" target='_blank'>Book an Appointment</Link></span></div>
                </div>
                <img src='/images/dubai-showroom.jpg' alt='The Experience Center  Dubai' />            
            </div>
        </div>
        {/* <div className='store-box'>
            <Link to="/book-appointment">
            <div className='store-overlaytext'>
                <div className='store-normaltext'>Meet us in-store <br /> or virtually <br /> to explore the <br /> magic of CHAASHNI</div>
                <div className='store-link'><span>Book an Appointment </span></div>
            </div>
                <img src='/images/book-an-appointment.jpg' alt='Book an Appointment' />
            </Link>
        </div> */}
    </div>
  )
}

export default StoreNew
